import React from "react";
import { Grid, Typography } from "@material-ui/core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import useStyles from "../../styles";
import { translate as t } from "../../../../translate/localization";

export default function VatCompanyMessage() {
  const { secondColumn, inputLabel } = useStyles();
  return (
    <Grid container item xs={12} justify="flex-end" alignItems="center">
      <Grid container item xs={6} className={secondColumn}>
        <FontAwesomeIcon icon="info-circle" />
        <Grid item xs={11}>
          <Typography variant="body2" className={inputLabel}>
            {t("request-section.vat-company-message")}
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  );
}
